var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaseWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 16.5H8.5C6.567 16.5 5 18.067 5 20V44C5 45.933 6.567 47.5 8.5 47.5H40.9751C40.4208 46.5783 39.8886 45.5723 39.4314 44.5H8.5C8.22386 44.5 8 44.2761 8 44V33.5H13V36C13 36.8284 13.6716 37.5 14.5 37.5H19.5C20.3284 37.5 21 36.8284 21 36V33.5H36V36C36 36.8284 36.6716 37.5 37.5 37.5H38.0098C38.113 34.8787 39.0233 32.4648 40.4992 30.5H8V20C8 19.7239 8.22386 19.5 8.5 19.5H48.5C48.7761 19.5 49 19.7239 49 20V25.5892C49.4918 25.5304 49.9924 25.5001 50.5 25.5001C51.0076 25.5001 51.5082 25.5304 52 25.5892V20C52 18.067 50.433 16.5 48.5 16.5H37V14C37 12.067 35.433 10.5 33.5 10.5H23.5C21.567 10.5 20 12.067 20 14V16.5ZM16 34.5V33.5H18V34.5H16ZM23 16.5H34V14C34 13.7239 33.7761 13.5 33.5 13.5H23.5C23.2239 13.5 23 13.7239 23 14V16.5Z",
    fill: "#3DE8CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 40.5C51.8807 40.5 53 39.3807 53 38C53 36.6193 51.8807 35.5 50.5 35.5C49.1193 35.5 48 36.6193 48 38C48 39.3807 49.1193 40.5 50.5 40.5Z",
    fill: "#3DE8CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 38C41 32.7533 45.2533 28.5 50.5 28.5C55.7467 28.5 60 32.7533 60 38C60 41.8134 57.9597 45.4603 56.0142 48.1053C54.0357 50.7951 51.9675 52.6985 51.5629 53.062C51.3102 53.2891 50.9429 53.4714 50.5 53.4714C50.057 53.4714 49.6898 53.2891 49.4371 53.062C49.0325 52.6985 46.9643 50.7951 44.9858 48.1053C43.0403 45.4603 41 41.8134 41 38ZM50.5 31.5C46.9101 31.5 44 34.4101 44 38C44 40.8294 45.5619 43.8254 47.4025 46.3277C48.5344 47.8666 49.7032 49.1274 50.5 49.9279C51.2968 49.1274 52.4656 47.8666 53.5975 46.3277C55.4381 43.8254 57 40.8294 57 38C57 34.4101 54.0899 31.5 50.5 31.5Z",
    fill: "#3DE8CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseWork);
export default __webpack_public_path__ + "static/media/case-work.25c0ca42cfb3d4d2bae17ee46888b455.svg";
export { ForwardRef as ReactComponent };